import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router";
// Style
import styles from "./app.module.css";
// utils
import { paperSizeOptions } from "./utils/paperSizeOptions";
import {
  copyToCanvas,
  createMaxSizeCanvas,
  GetImageFromUrl,
  hexToHsl,
} from "./utils/UTILS";
import { createPixelPortraitCanvas } from "./utils/createPixelNumberCanvas";
// comps
import Controls from "./controls/Controls";
import { createPixelPortraitPalette } from "./utils/createPalette";
import WorkshopInfo from "./comps/workshopInfo/WorkshopInfo";
import { downloadSheetsAsZip } from "./utils/downloadSheetsAsZip";
import FullPaletteCanvas from "./comps/fullPaletteCanvas/FullPaletteCanvas";
import { presets } from "./presets";

export const editors = ["Colour", "Greyscale"];

const sourceSwatchSize = 92;

// baseHue: 188,
// baseSaturation: 30,
const App = () => {
  const [params, setParams] = useState({});
  const [sheetData, setSheetData] = useState(null);
  const [settings, setSettings] = useState({});
  const [fullPaletteCanvas, setFullPaletteCanvas] = useState(null);
  const [sourceCanvas, setSourceCanvas] = useState(null);

  const canvasRef = useRef(null);

  let history = useHistory();

  // DERIVE SETTINGS FROM PARAMS
  useEffect(() => {
    if (!params.blockSize) return;
    let newSettings = { ...params };

    console.log("params: ", params);

    newSettings.presetSettings = presets.find(
      (preset) => preset.name === newSettings.preset
    );

    // add paper size object with mm etc
    newSettings.paperSize = paperSizeOptions.find(
      (opt) => opt.value === params.paperType
    );

    // combine crop data
    newSettings.crop = {
      left: params.cropLeft,
      right: params.cropRight,
      top: params.cropTop,
      bottom: params.cropBottom,
    };

    newSettings.downloadPrefix = newSettings.presetSettings
      ? newSettings.presetSettings.downloadPrefix
      : "my_download";
    const baseHSL = hexToHsl(params.baseColour);

    // just use numbers for labels
    let labels = [];
    for (let i = 0; i < params.totalColours; i++) {
      labels.push((i + 1).toString());
    }

    const isStickerVersion =
      params.outputType === "stickersFinished" ||
      params.outputType === "stickerCards";

    // generate pallete
    newSettings.palette = createPixelPortraitPalette({
      baseHue: baseHSL.hue,
      baseSaturation: baseHSL.saturation,
      labels,
      isStickerVersion,
      totalColours: params.totalColours,
      // customHues: [50, 50, 50, 36, 0, 0, 0],
      customHues: params.useCustomHues
        ? [
            52, 52, 52, 52, 52, 52, 52, 52, 140, 140, 140, 140, 140, 140, 140,
            140,
          ]
        : [],
    });

    setSettings(newSettings);
  }, [params]);

  // LOAD IN IMAGE
  useEffect(() => {
    if (!settings.presetSettings) return;

    // update one param
    const sp = new URLSearchParams(history.location.search);
    sp.set("baseColour", settings.presetSettings.colour);

    history.push({
      pathname: "/",
      search: "?" + sp.toString(),
    });

    GetImageFromUrl(`/images/${settings.presetSettings.imgName}`, (img) => {
      const src = createMaxSizeCanvas(img);
      setSourceCanvas(src);
    });
  }, [settings.presetSettings, history]);

  // Create the canvas
  useEffect(() => {
    const updateBlockCanvas = (canvas, sourceCanvas, settings) => {
      if (!canvas || !sourceCanvas || !settings.palette) return;

      const { canvas: portraitCanvas, sheetData: newSheetData } =
        createPixelPortraitCanvas(
          sourceCanvas,
          settings,
          fullPaletteCanvas,
          sourceSwatchSize
        );

      setSheetData(newSheetData);

      copyToCanvas(portraitCanvas, canvas);
    };

    updateBlockCanvas(canvasRef.current, sourceCanvas, settings);
  }, [sourceCanvas, settings, fullPaletteCanvas]);

  const onDownloadPack = () => {
    if (!sourceCanvas) return;

    downloadSheetsAsZip(sourceCanvas, {
      sheetData,
      fileName: settings.presetSettings.downloadPrefix,
      fullPaletteCanvas,
      sourceSwatchSize,
      ...settings,
    });
  };

  const onParamsChange = (newParams) => setParams(newParams);

  const swatches = settings && settings.palette && settings.palette.swatches;

  return (
    <div className={styles.app}>
      <Controls
        onChange={onParamsChange}
        onDownloadPack={() => onDownloadPack()}
      />

      {params.showInfo && (
        <WorkshopInfo
          downloadPrefix={settings.downloadPrefix}
          sourceSwatchSize={sourceSwatchSize}
          palette={settings.palette}
          outputType={settings.outputType}
          fullPaletteCanvas={fullPaletteCanvas}
          sheetData={sheetData}
          onDownloadPack={onDownloadPack}
          presetSettings={settings.presetSettings}
        />
      )}

      {swatches && (
        <FullPaletteCanvas
          outputType={settings.outputType}
          swatches={swatches}
          sourceSwatchSize={sourceSwatchSize}
          fullPaletteCanvas={fullPaletteCanvas}
          setFullPaletteCanvas={setFullPaletteCanvas}
        />
      )}

      <canvas ref={canvasRef} />
    </div>
  );
};

export default App;

// const paletteCanvasRef = useRef(null);

// useEffect(() => {
//   if (!fullPaletteCanvas) return;

//   const canvas = paletteCanvasRef.current;
//   canvas.width = fullPaletteCanvas.width;
//   canvas.height = fullPaletteCanvas.height;

//   const ctx = canvas.getContext("2d");
//   ctx.drawImage(fullPaletteCanvas, 0, 0);
// }, [fullPaletteCanvas]);

//{/* <canvas ref={paletteCanvasRef} style={{ display: "none", zIndex: -1 }} /> */}
